export const normalizeUrl = (url: string) => {
  return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
};

export const getSafeHttpUrl = (raw: string): string | null => {
  try {
    const parsed = new URL(raw);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? raw : null;
  } catch {
    return null;
  }
};
